export const AFTER_PARAM = 'after'
export const BEFORE_PARAM = 'before'

// Markören i URL:en är ett id (keyset-paginering). Ogiltiga värden tolkas som första sidan.
export function parseCursor(value: string | null): number | undefined {
  const parsed = Number(value)

  if (value === null || !Number.isInteger(parsed) || parsed < 1) {
    return undefined
  }

  return parsed
}

// Nollställer markören så att listan börjar om på första sidan.
export function clearCursor(params: URLSearchParams): void {
  params.delete(AFTER_PARAM)
  params.delete(BEFORE_PARAM)
}

// Byter ut båda markörerna – en gammal `after` bredvid en ny `before` tolkas av backend som en sida framåt.
export function writeCursor(params: URLSearchParams, cursorParam: string, id: number): void {
  clearCursor(params)
  params.set(cursorParam, String(id))
}
